import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a6899b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cv-auth" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cv-auth-blob",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "cv-auth-footnote mt-6" }

import logo from "@/assets/logotran2.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  props: {
    maxWidth: { default: 480 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "cv-auth-inner",
      style: _normalizeStyle({ maxWidth: `${_ctx.maxWidth}px` })
    }, [
      _createElementVNode("img", {
        src: _unref(logo),
        alt: "Cégvándor",
        class: "cv-auth-logo mb-8"
      }, null, 8, _hoisted_3),
      _createVNode(_component_v_card, {
        class: "cv-auth-card pa-8",
        rounded: "lg"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }),
      _createElementVNode("p", _hoisted_4, " © " + _toDisplayString(new Date().getFullYear()) + " Cégvándor ", 1)
    ], 4)
  ]))
}
}

})